<!-- Header -->
<div style="display: flex; flex-direction: row; justify-content: space-between;">
	<span mat-dialog-title
		role="heading">
	<span *ngIf="callByEform == undefined || callByEform == false">Insert Field</span>
	<span *ngIf="callByEform == true">Select Field</span>	 
	</span>
	<field-search (search)="applySearch($event)"
		style="padding-top: 10px; padding-right: 10px; flex-grow: .7;"></field-search>
</div>

<!-- Body -->
<mat-dialog-content>

	<!-- Virtualized Table -->
	<virtualized-table [data]="tableData"
		[cellTemplate]="rowTemplate"
		[columns]="columns"
		[paddingLeftPerLevel]="30"
		width="500px"
		height="75vh"></virtualized-table>
</mat-dialog-content>

<!--  Footer -->
<mat-dialog-actions>

	<!-- Left -->
	<div class="flex-footer-left">

	</div>

	<!-- Right -->
	<div class="flex-footer-right">
		<tyl-button image="Cancel.png"
			label="Cancel"
			(clickEvent)="close()"></tyl-button>
	</div>
</mat-dialog-actions>

<!-- Row Template -->
<ng-template #rowTemplate let-datum="datum" let-column="column">

	<!-- Header Row -->
	<ng-container *ngIf="datum.header">

		<!-- More Column -->
		<ng-container *ngIf="column == 'more' && datum.identifier != 'field'">
			<span style="padding-left: 4px"
				translate>More</span>
		</ng-container>

		<!-- Data Column -->
		<ng-container *ngIf="column == 'data'">

			<!-- Field -->
			<span *ngIf="datum.identifier == 'field'">
				<span style="padding-left: 10px"
					translate>Field</span>
			</span>

			<!-- Category -->
			<span *ngIf="datum.identifier == 'category'">
				<span translate>Category</span>
			</span>

			<!-- Object -->
			<span *ngIf="datum.identifier == 'object'">
				<span translate>Object</span>
			</span>
		</ng-container>
	</ng-container>

	<!-- Data Row -->
	<ng-container *ngIf="!datum.header">

		<!-- More Column -->
		<ng-container *ngIf="column == 'more' && datum.identifier != 'field'">
			<span class="material-icons" [ngClass]="{
					'detail-row-expanded-icon': datum.showChildren,
					'detail-row-collapsed-icon': !datum.showChildren
				}"
				style="padding-left: 12px"></span>
		</ng-container>

		<!-- Data Column -->
		<ng-container *ngIf="column == 'data'">

			<!-- Field -->
			<span *ngIf="datum.identifier == 'field'"
				style="padding-left: 10px">
				<data-query-field-label [field]="datum.data"></data-query-field-label>
			</span>

			<!-- Category -->
			<span *ngIf="datum.identifier == 'category'">
				{{datum.data.CategoryName}}
			</span>

			<!-- Object -->
			<span *ngIf="datum.identifier == 'object'">
				{{datum.data.ObjectName}}
			</span>
		</ng-container>
	</ng-container>
</ng-template>